export default __webpack_public_path__ + "static/media/draw-5.270829f9.jpg";